import React from 'react';
import './Page.css';

function AboutUs() {
  return (
    <div className="page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>About Us</h1>
        </div>
        
        <div className="principle-item">
          <h2>Seek margin of safety and don't overpay</h2>
          <p>
            Investing only in high quality businesses is our first line of defence. The second line of defence is to ensure that we do 
            not overpay for such businesses. Quality companies that we seek to own are usually expensive, baking in flawless performance. 
            Then once in a while, these quality businesses falter and are available at reasonable valuations either due to macro events or 
            due to short-term fears related to the business. That is when we try to initiate our investments. Such opportunities are available 
            infrequently and we would be lucky to have 4-5 such opportunities in any year. The real challenge is to wait patiently and do nothing 
            for most of the time.
          </p>
        </div>

        <div className="principle-item">
          <h2>Hold investments for long duration</h2>
          <p>
            Time is a friend of a high quality business. Hence, we try to hold our investments for a long duration, ideally forever. 
            In practice we exit our investments if the valuation becomes egregious or we realise that the quality of the business is worse 
            than our initial assessment. We have this preference for long holding periods for three reasons. First, quality businesses run by 
            competent and honest management teams keep finding ways of creating value over the long term. Second, knowledge and insights into 
            a business are far richer when researched with a permanent owner mindset. Third, our approach of buying high quality businesses with 
            a margin of safety translates into at best 4-5 investment opportunities a year, which is inconsistent with a high turnover portfolio.
          </p>
        </div>

        <div className="principle-item">
          <h2>Think independent, think contrarian, triangulate extensively</h2>
          <p>
            High quality businesses are available at a fair price only when they are going through a rough patch. To take advantage 
            of these situations we need to think independently and be contrarian. It would be impossible to do so without tuning out what 
            others are saying. We do not use sell side recommendations. We heavily filter and discount what we hear in management meetings. 
            We keenly analyse the historical performance of the company. We find conversations with ex-employees, competitors, channel partners, 
            suppliers and customers to be very helpful. We triangulate extensively across a range of inputs to form our own independent view 
            on the business.
          </p>
        </div>

        <div className="principle-item">
          <h2>Focus on micro over macro, and bottom up over top down</h2>
          <p>
            We are fundamental, bottom up investors and focus on the microeconomic drivers of a business. We do not make investments 
            based on macro and top-down views. Our view is that as a long term investor we have to be prepared for good and bad macro periods. 
            Hence the important thing is to buy resilient businesses with a margin of safety. Similarly, we do not have any view on market 
            valuations. It serves no purpose for us as we are not buying the market. Instead, we are assembling a portfolio of high quality 
            businesses when they are dislocated, often for their own idiosyncratic reasons.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
